import { Component, OnInit } from '@angular/core';
import { RateserviceService } from '../services/rateservice.service';
import { AdRate } from '../adrate';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from '../Globals';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { AdDataService } from '../services/addata.service';
import * as $ from 'jquery';


class displayadModelinf {
  adcategory: any;
  choosedAd: any;
  customradio: any;
  basicrate: any;
  widthinput: any;
  heightinput: any;
  adsizeinsqcm: any;
  uploadbtn: any;
  adsize: any;
  adcost: any;
  adContent: any;
  adContentPreview: any;
  gst: any;
  totalCost: any;
  imagename: string;
  adtype: string;
  adpage: string;
  flagupload: any;
  flagdate: any;
  noofdays: any;
  email: any;
  mobilenumber: any;
  addate: any;
  trxnid: any;
  fileData: File;
  uploadedFilePath: string;
  selectedDate: any;
  orderid: any;

  constructor() {
    this.adcategory = null;
    this.choosedAd = null;
    this.customradio = null;
    this.basicrate = null;
    this.widthinput = null;
    this.heightinput = null;
    this.adsizeinsqcm = null;
    this.uploadbtn = null;
    this.adsize = null;
    this.adcost = null;
    this.adContent = null;
    this.adContentPreview = null;
    this.gst = null;
    this.totalCost = null;
    this.imagename = null;
    this.adtype = null;
    this.adpage = null;
    this.flagupload = null;
    this.flagdate = null;
    this.noofdays = null;
    this.email = null;
    this.mobilenumber = null;
    this.addate = null;
    this.trxnid = null;
    this.fileData = null;
    this.uploadedFilePath = null;
    this.selectedDate = null;
    this.orderid = null;

  }

}
@Component({
  selector: 'app-classifiedad',
  templateUrl: './classifiedad.component.html',
  styleUrls: ['./classifiedad.component.css']
})
export class ClassifiedadComponent implements OnInit {

  displayadModel = {
    adcategory: null,
    choosedAd: null,
    customradio: null,
    basicrate: null,
    widthinput: null,
    heightinput: null,
    adsizeinsqcm: null,
    uploadbtn: null,
    adsize: null,
    adcost: null,
    adContent: null,
    adContentPreview: null,
    selectedDate : null,
    totalCost: null,
    imagename: null,
    adtype: null,
    adpage: null,
    flagupload: null,
    flagdate: null,
    noofdays: null,
    email: null,
    mobilenumber: null,
    addate: null,
    trxnid: null,
    fileData: null,
    uploadedFilePath: null,

    touched: null,
    orderid: null,

  };

  adDetails = {
    adcategory: 'ClassifiedTextAd',
    choosedAd: '',
    customradio: '',
    basicrate: '',
    widthinput: '',
    heightinput: '',
    adsizeinsqcm: '',
    uploadbtn: '',
    adContent: '',
    adContentPreview: '',
    adsize: '',
    adcost: '',
    totalCost: '',
    imagename: '',
    adtype: '',
    adpage: '2nd Page',
    noofdays: '',
    email: '',
    mobilenumber: '',
    addate: '',
    trxnid: '',
    flagupload: true,
    flagdate: true,
    fileData: File = null,
    uploadedFilePath: '',

    touched: '',
    orderid: '',
    selectedDate: [] = '',
  };


  public temp: any;
  rate: any;

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    public globals: Globals,
    private addata: AdDataService,
    private rateservice: RateserviceService,
  ) { }

  countWords(s) {
    s = s.replace(/(^\s*)|(\s*$)/gi, ''); // exclude  start and end white-space
    s = s.replace(/[ ]{2,}/gi, ' '); // 2 or more space to 1
    // s = s.replace(/\n /,"\n"); // exclude newline with a start spacing
    this.displayadModel.adsize = s.split(/[/ ,]/).filter((str) => {
      return str !== '';
    }).length;

    var words = s.split(' ');
    var tmp = '';
    if (words.length > 50) {
      for (var i = 0; i < 50; i++) {
        tmp += words[i] + ' ';
      }
      this.displayadModel.adContent = tmp;
    }

    if (this.displayadModel.adsize > 50) {
      this.displayadModel.adsize = 50
    }

    // if(this.displayadModel.adsize > 50){
    //   alert('Exceeded Maximum No Of Words 50')
    // }

    this.displayadModel.adcost = (this.displayadModel.adsize * this.rate).toFixed(2);
    // alert(this.x);
    // return (this.x);
    // return s.split(' ').filter(String).length; - this can also be used
  }
  // adCostCalc() {
  //   this.displayadModel.adcost = this.rate;
  //   this.displayadModel.flagdate = false;
  //   if (this.displayadModel.adsize > 7) {
  //     this.temp = this.displayadModel.adsize;
  //     this.displayadModel.adcost = (this.temp * 14);
  //   }
  //   // alert(this.displayadModel.adContent);
  //   sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));
  // }
  refillData() {
    (document.getElementById(
      'adContent'
    ) as HTMLInputElement).value = this.displayadModel.adContent;
    // this.displayadModel = JSON.parse(sessionStorage.getItem("Array"));
  }

  basicrate() {
    this.rateservice.getAdRate('classifiedtextAd').subscribe(
      data => {
        if (Array.isArray(data) && data.length) {
          const baserate = data[''];
          const resource = data[0];
          console.log(resource.adcost);
          this.rate = (resource.adcost);
          console.log(data);
        }
      });
  }

  ngOnInit() {

    $(document).ready(function() {

      $('textarea').keypress(function(event) {

          if (event.keyCode === 13) {
              event.preventDefault();
          }
      });
  });

    this.basicrate();

    this.displayadModel = this.adDetails;

    /* this.displayadModel = JSON.parse(sessionStorage.getItem("Array"));
     (document.getElementById(
       "adContent"
     ) as HTMLInputElement).value = this.displayadModel.adContent;*/

    this.displayadModel.choosedAd = this.route.routeConfig.component.name;
    console.log(this.displayadModel.choosedAd);

    this.displayadModel = JSON.parse(sessionStorage.getItem('Array'));
    const obj = this.addata.getAdData();
    this.displayadModel = (obj) ? obj : this.adDetails;
    console.log(obj);
  }

  onFormSubmit() {
    sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));
    let obj = this.addata.getAdData();
    obj = this.displayadModel;
    this.addata.setAdData(obj);
  }



}
